import { render, staticRenderFns } from "./PrivilegeListComponent.vue?vue&type=template&id=138f6219&scoped=true"
import script from "./PrivilegeListComponent.vue?vue&type=script&lang=js"
export * from "./PrivilegeListComponent.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeListComponent.vue?vue&type=style&index=0&id=138f6219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f6219",
  null
  
)

export default component.exports